import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentPortfolioSettingsOverviewData,
  type EnrollmentPortfolioSettingsOverviewSubmitOutput,
} from '../../../models'

export const getEnrollmentPortfolioSettingsOverviewDataMock: EnrollmentPortfolioSettingsOverviewData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/portfolio-settings-overview',
}

export const submitEnrollmentPortfolioSettingsOverviewDataMock: EnrollmentPortfolioSettingsOverviewSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/portfolio-settings',
}

export const mockGetEnrollmentPortfolioSettingsOverviewData = graphql.mutation(
  'getEnrollmentPortfolioSettingsOverviewData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentPortfolioSettingsOverviewDataMock } })
  },
)

export const mockSubmitEnrollmentPortfolioSettingsOverviewData = graphql.mutation(
  'submitEnrollmentPortfolioSettingsOverviewData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentPortfolioSettingsOverviewDataMock } })
  },
)

export const mockEnrollmentPortfolioSettingsOverview = [
  mockGetEnrollmentPortfolioSettingsOverviewData,
  mockSubmitEnrollmentPortfolioSettingsOverviewData,
]
